<div class="avatar-dialog-overlay">
  <div class="avatar-dialog">
    <div class="avatar-dialog__header">
      <h2 class="avatar-dialog__title">{{ 'CHANGE_AVATAR' | translate }}</h2>
      <button class="avatar-dialog__close" (click)="onClose()" [attr.aria-label]="'COMMON.CLOSE' | translate">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="avatar-dialog__body">
      <div class="avatar-preview-container">
        @if (isCameraActive()) {
          <div class="camera-preview">
            <video #videoElement autoplay playsinline></video>
            <div class="camera-overlay">
              <div class="face-guide"></div>
            </div>
          </div>
        } @else if (previewUrl()) {
          <div class="avatar-preview">
            <img [src]="previewUrl()" alt="Avatar Preview" />
          </div>
        } @else {
          <div class="avatar-placeholder">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <p>{{ 'SELECT_FILE' | translate }}</p>
          </div>
        }
      </div>

      <div class="dialog-actions-container">
        @if (isCameraActive()) {
          <div class="camera-controls">
            <lib-button variant="primary" (buttonClick)="capturePhoto()">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
              {{ 'CAPTURE_PHOTO' | translate }}
            </lib-button>
            <lib-button variant="secondary" (buttonClick)="stopCamera()">
              {{ 'COMMON.CANCEL' | translate }}
            </lib-button>
          </div>
        } @else {
          <div class="file-input-wrapper">
            <div class="upload-options">
              <lib-button 
                variant="outline" 
                (buttonClick)="fileInput.click()" 
                [disabled]="isUploading()"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
                {{ (previewUrl() ? 'CHANGE_FILE' : 'SELECT_FILE') | translate }}
              </lib-button>

              <lib-button 
                variant="outline" 
                (buttonClick)="startCamera()" 
                [disabled]="isUploading()"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                  <circle cx="12" cy="13" r="4"></circle>
                </svg>
                {{ 'USE_CAMERA' | translate }}
              </lib-button>
            </div>
            
            <p class="file-hint">{{ 'MAX_FILE_SIZE' | translate }}: 10MB</p>
            <input #fileInput type="file" (change)="onFileSelected($event)" accept="image/*" style="display: none;" />
          </div>
        }
      </div>
    </div>

    <div class="avatar-dialog__footer">
      <lib-button 
        variant="secondary" 
        (buttonClick)="onClose()" 
        [disabled]="isUploading()"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </lib-button>
      <lib-button 
        variant="primary" 
        (buttonClick)="onSave()" 
        [disabled]="!selectedFile() || isUploading()"
        [loading]="isUploading()"
      >
        {{ 'COMMON.SAVE' | translate }}
      </lib-button>
    </div>
  </div>
</div>
